import { getPropKeys, svgIcon } from '@yzfe/svgicon';
export { setOptions } from '@yzfe/svgicon';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var VueSvgIcon = {
    functional: true,
    props: getPropKeys(),
    render: function (h, context) {
        var result = svgIcon(context.props);
        return h('svg', __assign(__assign({}, context.data), { attrs: __assign({ viewBox: result.box }, context.data.attrs), staticStyle: __assign(__assign({}, result.style), context.data.staticStyle), staticClass: result.className +
                (context.data.staticClass
                    ? " " + context.data.staticClass
                    : ''), domProps: {
                innerHTML: result.path,
            } }));
    },
};

export { VueSvgIcon };
//# sourceMappingURL=index.esm.js.map
